import React from 'react';
import {
    useCreateStatusMutation,
    useDeleteStatusMutation,
    useGetStatusQuery,
    useUpdateStatusMutation,
} from '../../../services/fixedAssets/fixedAssets.service';
import { skipToken } from '@reduxjs/toolkit/query';
import { FixedAssetStatus } from '../../../types/FixedAsset.types';
import useBaseForm from '../../Form/hooks/useBaseForm';

const UseFixedAssetStatusForm = (id: string) => {
    const { data: activeStatus, isLoading: isLoadingStatus } =
        useGetStatusQuery(id ? id : skipToken);
    const [createStatus] = useCreateStatusMutation();
    const [updateStatus] = useUpdateStatusMutation();
    const [deleteStatus] = useDeleteStatusMutation();

    const blankStatus: FixedAssetStatus = {
        sortOrder: null,
        code: '',
        description: '',
        isInService: false,
        isDisposal: false,
    };

    const {
        fields,
        handleFieldChange,
        formMethods,
        toastProps,
        onCreate,
        onUpdate,
        onDelete,
        closeForm,
    } = useBaseForm({
        closePath: '/accounting/fixedAssets/status',
        blankEntity: blankStatus,
        activeEntity: activeStatus,
        createEntity: () => {
            return createStatus({ postBody: fields });
        },
        updateEntity: () => {
            return updateStatus({
                id: id as unknown as number,
                postBody: fields,
            });
        },
        deleteEntity: () => {
            return deleteStatus(id);
        },
    });

    return {
        fields,
        handleFieldChange,
        formMethods,
        toastProps,
        onCreate,
        onUpdate,
        onDelete,
        closeForm,
        isLoadingStatus,
    };
};

export default UseFixedAssetStatusForm;
